import React from 'react';
import styles from './PreviewFieldBtn.module.scss';
import RoundedButton from '../../../../../../components/RoundedButton/RoundedButton';
import { typeIds } from '../../../../constants/common';
import { filedNames } from '../../constants';

const PreviewFieldBtn = ({ form, onChange }) => {
  const { getFieldValue } = form;

  const typeValue = getFieldValue(filedNames.typeId);

  if (typeValue !== typeIds.advertisement) return null;

  return (
    <RoundedButton
      onClick={onChange}
      type="primary"
      className={styles.btnCustom}
      text="Предпросмотр"
    />
  );
};

export default PreviewFieldBtn;
